module.exports = __webpack_public_path__ + "img/logo.51033684.png";